//imports
import {
	GET_USER_INFO,
	GET_USER_INFO_RESULT,
	LOGOUT,
	REFRESH_TOKEN,
	REFRESH_TOKEN_RESULT,
	GET_SYSTEM_PREF_RESULT,
	GET_ACCESS_ELD_APOLLO,
	GET_ACCESS_ELD_APOLLO_RESULT,
	CHANGE_SALESFORCE_STATUS,
	CHANGE_SALESFORCE_STATUS_RESULT,
	SWITCH_ACCOUNT,
	SWITCH_ACCOUNT_RESULT,
	CLEAR_REDUX
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
	loading: false,
	user: null,
	error: null,
	refreshTokenResult: false,
	authenticatedId: null,
	systemPreference: null,
	accessEldApollo: null,
	loadingAccessEldApollo: false,
	salesForceStatus: false,
	authId: null,
	accounts: [],
	switchingAccount: false,
	switchAccountError: null
};

//change redux object
export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case GET_USER_INFO:
			return { ...state, loading: true };

		case GET_USER_INFO_RESULT: {
			const user = action.payload;
			if (!user) {
				return { ...INIT_STATE, loading: false, error: 'User not found' };
			}
			const companyId = user?.companyId;
			const userId = user?.subUserId;
			const authenticatedId = companyId + (userId ? "_" + userId : "");

			const authId = `PX_${companyId}${userId ? `_${userId}` : ""}`;

			// accounts is an array from the payload
			const accounts = user?.users?.map((u) => ({
			authId: `PX_${u.companyId}${u.isSubUser ? `_${u.id}` : ""}`,
			composeName: `${u.companyTitle} - ${u.isSubUser ? 'User' : 'Account'}`,
			email: u.email,
			...u
			})) || [];
			return { ...state, loading: false, user, authenticatedId, authId, accounts };
		}

		case GET_SYSTEM_PREF_RESULT:
			return { ...state, systemPreference: action.payload }

		case REFRESH_TOKEN:
			return { ...state, refreshTokenResult: false };

		case REFRESH_TOKEN_RESULT:
			return { ...state, refreshTokenResult: action.payload };

		case LOGOUT:
			return { ...state, loading: false, user: null, error: null };

		case GET_ACCESS_ELD_APOLLO:
			return { ...state, loadingAccessEldApollo: true };

		case GET_ACCESS_ELD_APOLLO_RESULT:
			return { ...state, loadingAccessEldApollo: false, accessEldApollo: action.payload };

		case CHANGE_SALESFORCE_STATUS:
			return { ...state };

		case CHANGE_SALESFORCE_STATUS_RESULT:
			return { ...state, salesForceStatus: action.payload }
		
		case SWITCH_ACCOUNT:
			return { ...state, switchingAccount: true, switchAccountError: null };
		
		case SWITCH_ACCOUNT_RESULT:
			return { 
				...state, 
				switchingAccount: false, 
				switchAccountError: action.payload.error 
			};;

		case CLEAR_REDUX:
			return ["", "AUTHCOMPONENT"].includes(action.payload.option)
				? action.payload.parameters
					? { ...state, ...action.payload.parameters }
					: { ...INIT_STATE }
				: { ...state }

		default:
			return state;
	}
};
